<template>
  <v-container>
    <!-- <v-col>
        <v-btn @click="testESP()">test ESP</v-btn>
      </v-col> -->
    <v-row>
      <v-col> </v-col>
    </v-row>
    <v-row justify="space-around">
      <!-- <v-col v-for="group in groups" cols="3">
        <GroupViewCard :groupInfo="group" />
      </v-col> -->
      <v-col>
        <v-card elevation="9">
          <v-card-text>
            <v-row>
              <v-col>
                <span style="font-weight: bold; color: black; font-size: 16pt">
                  به پنل کاربری Goldware خوش آمدید.
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span>
                  کاربر گرامی این پنل برای دسترسی به دستگاه ها از طریق وب طراحی و پیاده سازی شده است در صورت وجود هرگونه
                  مشکل
                  در کارکرد با پشتیبانی در تماس باشید.
                </span>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import "../style.scss";
import axios from "axios";
export default {
  name: "Home",
  components: {
    HelloWorld,
  },
  data() {
    return {
      dashboard: {},
      requestParams: {},
      groups: [],
    };
  },
  mounted() { },
  methods: {},
};
</script>

<style scoped>
span {
  font-family: "IranSans";
  font-size: 12pt;
}

div {
  text-align: center !important;
}
</style>
